<div class="modal fade" bsModal #recordsModal="bs-modal" [config]="{backdrop: 'static'}"
     tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title pull-xs-left">{{title}}</h4>
                <button type="button" class="close float-sm-right" aria-label="Close" (click)="closeModal()">
                    <span aria-hidden="true"><img src="assets/img/icon-close-reversed.png"></span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <span class="modal-sub-header">Select Resident:</span>
                    <div>
                        <input type="search" [(ngModel)]="searchText" (ngModelChange)="searchResidents($event)" placeholder="Search" style="width: 330px; margin-bottom: 10px">
                    </div>
                    <div class="resident-content-area">
                        <div *ngFor="let resident of filteredResidents">
                            <label class="radio">
                                <input type="radio" name="residents" [value]="resident.IsSelected" [checked]="resident.IsSelected" (change)="selectResident(resident)">
                                <span></span>
                                <span class="checkbox-label">{{resident.Name}}</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <span class="">Print the drug monographs for all medications?</span>
                    <div class="monograph-content-area">
                        <div>
                            <label class="radio">
                                <input type="radio" name="monograph" [(ngModel)]="printMonographs" [value]="true" [checked]="printMonographs">
                                <span></span>
                                <span class="checkbox-label">Yes</span>
                            </label>
                        </div>
                        <div>
                            <label class="radio">
                                <input type="radio" name="monograph" [(ngModel)]="printMonographs" [value]="false" [checked]="!printMonographs">
                                <span></span>
                                <span class="checkbox-label">No</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <div class="float-left text-align-left">
                    <button class="btn btn-primary" (click)="closeModal()">Cancel</button>
                </div>
                <div class="float-right text-align-right">
                    <button (click)="generatePDF()" [disabled]="!canGenerateReport()" class="btn btn-primary">
                        <img src="assets/img/loading.gif" height="25" width="25" [hidden]="hideSpinner">Finished: View LOA Form</button>
                </div>
            </div>
        </div>
    </div>
</div>